import { useState } from "react"
import { Loader2, CheckCircle2, Unplug } from "lucide-react"
import { Button } from "@/components/ui/button"
import { getCanvaAuthUrl, disconnectCanva } from "@/lib/canva-client"
import { useCanvaConnection } from "@/lib/use-api"

export function CanvaConnectionButton() {
  const { data: connection, mutate } = useCanvaConnection()
  const [isLoading, setIsLoading] = useState(false)

  async function handleConnect() {
    setIsLoading(true)
    try {
      const { authUrl } = await getCanvaAuthUrl()
      window.location.href = authUrl
    } catch (err) {
      console.error("Failed to get Canva auth URL:", err)
      setIsLoading(false)
    }
  }

  async function handleDisconnect() {
    setIsLoading(true)
    try {
      await disconnectCanva()
      mutate({ connected: false })
    } catch (err) {
      console.error("Failed to disconnect Canva:", err)
    } finally {
      setIsLoading(false)
    }
  }

  if (connection?.connected) {
    return (
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1.5 rounded-full bg-emerald-100 px-2.5 py-0.5 text-xs font-medium text-emerald-700">
          <CheckCircle2 className="h-3 w-3" />
          Connected
        </div>
        <Button variant="outline" size="sm" onClick={handleDisconnect} disabled={isLoading}>
          {isLoading ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <Unplug className="mr-1.5 h-3.5 w-3.5" />}
          Disconnect
        </Button>
      </div>
    )
  }

  return (
    <Button onClick={handleConnect} disabled={isLoading} size="sm">
      {isLoading ? (
        <>
          <Loader2 className="mr-2 h-3.5 w-3.5 animate-spin" />
          Connecting...
        </>
      ) : (
        "Connect Canva"
      )}
    </Button>
  )
}
